import { FirestoreSourceRow } from '@creative-kit/shared';
import { action, makeObservable, observable } from 'mobx';
import { CloudinaryImage } from '@cloudinary/url-gen';
import type { RootStore } from '.';

interface RowContext {
  sessionId: string;
  sourceId: string;
  rowId: string;
}

export class UiImageModal {
  image?: FirestoreSourceRow['image'] | FirestoreSourceRow['attachment'];
  private rowContext?: RowContext;
  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      image: observable,
      setImage: action.bound,
      clearImage: action.bound,
    });
  }

  setImage(
    image: FirestoreSourceRow['image'] | FirestoreSourceRow['attachment'],
    context?: RowContext,
  ) {
    this.image = image;
    this.rowContext = context;
  }

  clearImage() {
    this.image = undefined;
    this.rowContext = undefined;
  }

  downloadImage = () => {
    if (this.image) {
      const imageSource = new CloudinaryImage(
        this.image.storage.publicId,
        { cloudName: this.image.storage.cloudName },
        { secure: true },
      ).addFlag('attachment');

      const a = document.createElement('a');
      a.href = imageSource.toURL();
      a.download = this.image.originalFilename;
      a.click();

      // Track the download if we have row context
      if (this.rowContext) {
        const { sourceId, rowId } = this.rowContext;
        const row = this.rootStore.sourcesStore.sources[sourceId]?.rows[rowId];
        if (row && 'trackDownload' in row) {
          (row as { trackDownload: () => void }).trackDownload();
        }
      }
    }
  };
}
